import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { AddLeaveForm } from '@/features/guide/components/AddLeaveForm';
import { BlockedDatesList } from '@/features/guide/components/BlockedDatesList';
import {
  useGuideBlockedDates,
  useGuideBookedDays,
} from '@/features/guide/hooks/useGuideAvailability';
import { GuidePageHeader } from '@/features/guide/components/GuidePageHeader';

export function GuideAvailabilityPage() {
  const [leaveDialogOpen, setLeaveDialogOpen] = useState(false);
  const { data: entries = [], isLoading, error } = useGuideBlockedDates();
  const bookedDays = useGuideBookedDays();

  return (
    <Box>
      <GuidePageHeader
        title="Manage Unavailability"
        subtitle="Block personal leave dates here. Booked hours appear automatically; the rest of those days stays bookable."
        actions={
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => setLeaveDialogOpen(true)}>
            Block leave dates
          </Button>
        }
      />
      <BlockedDatesList
        entries={entries}
        bookedDays={bookedDays.data ?? []}
        isLoading={isLoading || bookedDays.isLoading}
        error={(error ?? bookedDays.error) as Error | null}
      />

      <Dialog
        open={leaveDialogOpen}
        onClose={() => setLeaveDialogOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ fontWeight: 700 }}>Block leave dates</DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <AddLeaveForm onSuccess={() => setLeaveDialogOpen(false)} usePaper={false} />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
